import React, { useState } from "react";
import PlansSectionHeader from "./PlansSectionHeader";
import Spinner from "../common/Spinner/Spinner";
import ScriptTag from "react-script-tag";
import getEnvEndpoints from "../../utils/endpoints";
import PlanCard from "./PlanCard";
import Modal from "../common/Modal";
import LogService from "../../utils/logs";
import { useHistory } from "react-router";
import useIsMounted from "../../hooks/useIsMounted";

const endpoints = getEnvEndpoints();

const PlansSectionMemberPaid = ({ plans, onSubscribe }) => {
  const [showSubscriptionLoading, setShowSubscriptionLoading] = useState(false);
  const history = useHistory();
  const isMounted = useIsMounted();

  const monthPlan = plans.find((i) => i.frequency === "MONTH");
  const yearPlan = plans.find((i) => i.frequency === "YEAR");

  const startSubscription = () => {
    setShowSubscriptionLoading(true);
  };

  const finishSubscription = async (plan) => {
    await onSubscribe(plan);
    LogService.logSubscription();
    isMounted.current && setShowSubscriptionLoading(false);
    history.push("/home");
  };

  return (
    <>
      {showSubscriptionLoading && (
        <Modal onClose={() => setShowSubscriptionLoading(false)} onClickOutside={false} loading={showSubscriptionLoading}>
          <div className="text-center text-2xl font-bold">Subscribing...</div>
          <div className="text-center mt-5">
            That can take several moments...
          </div>
          <div className="flex justify-center my-5">
            <Spinner />
          </div>
        </Modal>
      )}

      <PlansSectionHeader
        title=""
        description='Enjoy access to PMIstandards+ as a benefit of your PMI Membership. Click "Subscribe Now" to sync your member credentials with the PMIstandards+ access.'
      />

      <div className="container md:w-3/4 flex flex-col mx-auto">
        <div
          className={`flex flex-col lg:flex-row items-center items-stretch justify-center mt-24`}
        >
          <PlanCard
            header=""
            tagline={
              <span>
                Enjoy PMIstandards+
                <br />
              </span>
            }
            paypayId="monthly-button"
            color="border-orange-brand-500"
            onStart={startSubscription}
            onEnd={finishSubscription}
            isFree={true}
            isMember={true}
            hasSubscribeButton={true}
          />

        </div>
      </div>
    </>
  );
};

export default PlansSectionMemberPaid;
